import { render, staticRenderFns } from "./GroupManage.vue?vue&type=template&id=754b9c62&scoped=true&"
import script from "./GroupManage.vue?vue&type=script&lang=js&"
export * from "./GroupManage.vue?vue&type=script&lang=js&"
import style0 from "./GroupManage.vue?vue&type=style&index=0&id=754b9c62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754b9c62",
  null
  
)

export default component.exports